import React from 'react';

import AvatarBase from '@material-ui/core/Avatar';

const Avatar = (props) => <AvatarBase {...props} />;

export default Avatar;
